<template>
  <div class="writerBox clearfix">
    <chapterList
      :volumnList="volumnList"
      v-if="islist"
      @isOpenVo="isOpenVo"
      :volumechooseId="volumechooseId"
      @volumeshow="volumeshow"
      :isShowList="isShowList"
      @chapterId="chapterId"
      :newChapter="newChapter"
    ></chapterList>
    <authorWrite
      v-show="isShowChapter"
      v-if="islist"
      :mainInfo="mainInfo"
      @checkSuccess="checkSuccess"
    ></authorWrite>
    <div v-show="!isShowChapter" class="volumeCon fr">
      <h4 class="clearfix">
        {{ volumeintro.iname }} <span>本卷章节{{ volumeintro.size }}章</span>
        <button class="setVoName fr" @click="delChapter">
          删除
        </button>
        <button
          v-show="!isOpenVoInfo"
          @click="openSetting"
          class="setVoName fr"
        >
          修改
        </button>
        <button v-show="isOpenVoInfo" @click="editVoInfo" class="setVoName fr">
          保存
        </button>
      </h4>
      <ul v-show="!isOpenVoInfo">
        <li class="voname"><span>分卷名称</span>{{ volumeintro.iname }}</li>
        <li class="voCon"><span>分卷介绍</span>{{ volumeintro.iintroduce }}</li>
      </ul>
      <div class="setVoBox" v-show="isOpenVoInfo">
        <input
          type="text"
          placeholder="请输入分卷名"
          v-model="volumeintro.iname"
        />
        <textarea
          placeholder="请输入卷的介绍"
          v-model="volumeintro.iintroduce"
        ></textarea>
      </div>
    </div>
    <!-- 引入弹窗 -->
    <pop
      :isShowPop="isShowPop"
      :isShowCreateVo="isShowCreateVo"
      :isShowPublish="isShowPublish"
      @changeobj="changeobj"
      @isSuVo="isSuVo"
      :mainInfo="mainInfo"
      :bookname="bookname"
      @changeradio="changeradio"
      :chapterType="chapterType"
      @publishChapter="publishChapter"
    ></pop>
    <noneHint
      v-if="!islist"
      :noneListhint="noneListhint"
      @elseUrl="elseUrl"
    ></noneHint>
    <!-- 
         :rollList="rollList"
      :rollvalue="rollvalue"
      :radio="radio"
     -->

    <!-- 引入提示弹窗 -->
    <surePop :ApplyInfo="ApplyInfo" @passbind="passbind"></surePop>
    <surePop :ApplyInfo="deleteInfo" @passbind="deletebind"></surePop>
  </div>
</template>

<script>
import {
  getPublishVo,
  getvolume,
  getnewCon,
  getEditCon,
  publishOldChapter,
  editVolume,
  delVolume
} from "apiurl/author";
import { gettoll } from "utils/storage";
import { mapState } from "vuex";
export default {
  metaInfo: {
    title: "已发布-源石阅读"
  },
  data() {
    return {
      news: [
        "公告：近期接到第三方渠道投诉，请作者勿在章节正文内添加个人微信号、qq群、qq号等联系方式，违者被发现将扣除当月全勤！"
      ],
      chapterType: 0,
      volumnList: [],
      islist: true, //是否有章节
      noneListhint: {
        msg: "没有章节~~",
        btnmsg: "新建章节",
        isbtn: true,
        istype: "book"
      },
      firstVoId: null,
      isShowPop: false, // 控制弹窗时候显示
      isShowCreateVo: false, // 控制添加卷的弹窗是否显示
      isShowPublish: false, // 控制发布弹窗
      radio: 0,
      mainInfo: {
        mainCount: 0, // 字数
        mainCon: "", // 正文
        chapterTitle: "", //章节标题
        authorCon: "", //作者的话,
        volumelist: [],
        typelist: [],
        chapterType: "1",
        rollvalue: "0",
        isSavebtn: false,
        isPubtn: true,
        isSave: true // 是否可保存
      },
      saveChapter: {
        mainCon: "", // 正文
        chapterTitle: "", //章节标题
        authorCon: "" //作者的话,
      },
      isShowList: false, // 展示带分卷的列表
      isShowChapter: true, // 展示分卷内容还是章节内容
      volumeintro: {}, // 分卷信息
      newChapter: null, //章节id
      volumechooseId: "", //分卷id
      isChange: "",
      ApplyInfo: {
        isShow: false,
        title: "温馨提示",
        content: "更改内容尚未保存~~",
        hint: "* 更改的内容将消失",
        sure: "切换",
        cancle: "取消"
      }, //弹窗
      deleteInfo: {
        isShow: false,
        title: "温馨提示",
        content: "确定要删除此分卷~~",
        hint: "* 分卷将永久删除",
        sure: "删除",
        cancle: "取消"
      }, //弹窗
      isOpenVoInfo: false //是否开启修改
    };
  },
  created() {
    this.$nextTick(() => {
      if (this.$route.params.id > 0) {
        // 获取全部章节分卷
        this.getalllist();
        // 判断是否可选收费章节
        //   获取分卷
        this.getVolist();
        if (gettoll() === true) {
          this.mainInfo.typelist = [
            { value: "1", desc: "免费章节" },
            { value: "2", desc: "付费章节" },
            { value: "3", desc: "公告" }
          ];
        } else {
          this.mainInfo.typelist = [
            { value: "1", desc: "免费章节" },
            { value: "3", desc: "公告" }
          ];
        }
      } else {
        this.islist = false;
        this.noneListhint = {
          msg: "作品还没创建哦~~",
          btnmsg: "创建作品",
          isbtn: true,
          istype: "book"
        };
      }
    });
  },
  computed: mapState({
    bookname: state => state.author.bookName
  }),
  methods: {
    // 打开vo弹窗
    isOpenVo(value) {
      this.isShowPop = value;
      this.isShowCreateVo = value;
    },
    // 关闭vo弹窗
    changeobj(obj) {
      this.isShowPop = obj.isShowPop;
      this.isShowPop = obj.isShowCreateVo;
    },
    changeradio(radio) {
      this.radio = radio;
    },
    /* 获取添加卷是否成功 */
    isSuVo(isSuc) {
      if (isSuc.data) {
        this.getVolist();
        this.isShowCreateVo = false;
        this.isShowPop = false;
      }
    },
    // 没有章节点击跳转
    elseUrl() {
      if (this.$route.params.id > 0) {
        this.$router.push(`/authorManage/newChapter/${this.$route.params.id}`);
      } else {
        this.$router.push(`/authorManage/bookSetting/${this.$route.params.id}`);
      }
    },
    //内容未保存仍要切换
    passbind(value) {
      if (value) {
        this.getChapterCon(this.saveId);
        this.newChapter = this.saveId;
      }
    },
    // 获取章节目录
    getalllist() {
      getPublishVo(this.$route.params.id)
        .then(res => {
          if (res.success) {
            this.volumnList = res.data;
            /* this.volumnList.forEach(item => {
                                  item.chapters.forEach(chapter => {
                                    if (chapter.publishTime) {
                                      chapter.publishTime = chapter.publishTime.slice(2, 19);
                                    }
                                  });
                                }); */
            if (this.volumnList.length > 0) {
              this.firstVoId = res.data[0].id;
              // 最新章节内容
              this.getNewChapterCon();
            } else {
              this.islist = false;
            }
          }
        })
        .catch(() => {});
    },
    // 获取分卷
    async getVolist() {
      let res = await getvolume(this.$route.params.id);
      if (res.success) {
        this.mainInfo.volumelist = res.data;
        this.mainInfo.volumelist.unshift({ id: "0", name: "未分卷" });
      }
    },
    // 展示分卷消息
    volumeshow(id) {
      var self = this;
      this.volumnList.forEach(item => {
        if (item.id === id) {
          //console.log("tagss3", item.id, item);
          self.isShowChapter = false;
          self.volumeintro = {
            iname: item.iname,
            iintroduce: item.iintroduce,
            size: item.chapters? item.chapters.length: 0,
            id: item.id
          };
        }
      });
    },
    // 最新章节内容
    async getNewChapterCon() {
      let res = await getnewCon({ bookId: this.$route.params.id });
      if (res.success) {
        this.mainInfo.rollvalue = res.data.volumeId;
        this.mainInfo.chapterType = res.data.type;
        this.mainInfo.chapterTitle = res.data.iname;
        this.mainInfo.mainCon = res.data.icontent;
        this.mainInfo.authorCon = res.data.iadditional;
        this.mainInfo.mainCount = res.data.words;
        this.volumechooseId = res.data.volumeId;
        this.newChapter = res.data.id;
        this.saveId = res.data.id;
        this.saveChapter = {
          chapterTitle: res.data.iname,
          mainCon: res.data.icontent,
          authorCon: res.data.iadditional
        };
        if (res.data.type == 1) {
          this.mainInfo.chapterType = "3";
        } else {
          if (res.data.free) {
            this.mainInfo.chapterType = "1";
          } else {
            this.mainInfo.chapterType = "2";
          }
        }
      }
    },
    // 获取章节内容
    async chapterId(id) {
      this.isShowChapter = true;
      this.saveId = id;
      if (
        this.saveChapter.chapterTitle == this.mainInfo.chapterTitle &&
        this.saveChapter.mainCon == this.mainInfo.mainCon &&
        this.saveChapter.authorCon == this.mainInfo.authorCon
      ) {
        this.newChapter = id;
        this.getChapterCon(id);
      } else {
        this.ApplyInfo.isShow = true;
      }
    },
    async getChapterCon(id) {
      let res = await getEditCon({ chapterId: id });
      if (res.success) {
        this.mainInfo.rollvalue = res.data.volumeId;
        this.mainInfo.chapterType = res.data.type;
        this.mainInfo.chapterTitle = res.data.iname;
        this.mainInfo.mainCon = res.data.icontent;
        this.mainInfo.authorCon = res.data.iadditional;
        this.mainInfo.mainCount = res.data.words;
        // 备份
        this.saveChapter = {
          chapterTitle: res.data.iname,
          mainCon: res.data.icontent,
          authorCon: res.data.iadditional
        };
        if (res.data.type == 1) {
          this.mainInfo.chapterType = "3";
        } else {
          if (res.data.free) {
            this.mainInfo.chapterType = "1";
          } else {
            this.mainInfo.chapterType = "2";
          }
        }
      }
    },
    // 验证成功，打开发布弹窗
    checkSuccess() {
      this.isShowPublish = true;
      this.isShowPop = true;
    },
    // 发布章节
    publishChapter(time) {
      var main = this.mainInfo;
      let data = {
        bookId: this.$route.params.id,
        additional: main.authorCon,
        content: main.mainCon,
        freeType: main.chapterType,
        name: main.chapterTitle,
        submitType: "publish",
        volumeId: main.rollvalue,
        chapterId: this.newChapter
      };
      if (time !== "") {
        data.time = time;
        data.submitType = "tpublish";
      }
      publishOldChapter(this.qs.stringify(data))
        .then(res => {
          if (res.success) {
            this.isShowPublish = false;
            this.isShowPop = false;
            this.$message({
              message: "发布成功，并保存至已发布章节",
              type: "success"
            });
            this.saveChapter = {
              chapterTitle: this.mainInfo.chapterTitle,
              mainCon: this.mainInfo.mainCon,
              authorCon: this.mainInfo.authorCon
            };
            this.getalllist();
          }
        })
        .catch(() => {});
    },
    // 是否开启修改
    openSetting() {
      this.isOpenVoInfo = true;
    },
    // 删除章节提示
    delChapter() {
      this.deleteInfo.isShow = true;
    },
    // 删除章节
    deletebind(value) {
      if (value) {
        delVolume({
          bookId: this.$route.params.id,
          volumeId: this.volumeintro.id
        })
          .then(res => {
            if (res.success) {
              this.$message({
                message: "已删除此分卷",
                type: "success"
              });
              this.getVolist();
              this.getalllist();
            }
          })
          .catch(() => {});
      }
    },
    // 编辑卷
    editVoInfo() {
      if (this.volumeintro.iname.replace(/\s*/g, "") == "") {
        this.$message({
          message: "分卷名称不能为空",
          type: "error"
        });
      } else {
        let data = this.qs.stringify({
          bookId: this.$route.params.id,
          name: this.volumeintro.iname,
          volumeId: this.volumeintro.id
        });
        //console.log("tag", data);
        editVolume(data)
          .then(res => {
            if (res.success) {
              this.isOpenVoInfo = false;
              this.getVolist();
              this.getalllist();
              this.$message({
                message: "修改成功",
                type: "success"
              });
            }
          })
          .catch(() => {});
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    let $this = this;
    if (
      $this.saveChapter.chapterTitle == $this.mainInfo.chapterTitle &&
      $this.saveChapter.mainCon == $this.mainInfo.mainCon &&
      $this.saveChapter.authorCon == $this.mainInfo.authorCon
    ) {
      next();
    } else {
      let a = window.confirm("离开页面更改的内容将丢失！");
      if (a) {
        next();
      } else {
        next(false);
      }
    }
  },
  mounted() {
    let $this = this;
    window.onbeforeunload = function(e) {
      e = e || window.event;
      // 兼容IE8和Firefox 4之前的版本
      if (
        $this.saveChapter.chapterTitle == $this.mainInfo.chapterTitle &&
        $this.saveChapter.mainCon == $this.mainInfo.mainCon &&
        $this.saveChapter.authorCon == $this.mainInfo.authorCon
      ) {
        //console.log("tag", "可刷新");
      } else {
        if (e) {
          e.returnValue = "关闭提示";
        }
        // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
        return "关闭提示";
      }
    };
  }
};
</script>
<style lang="stylus" scoped>
@import '~@/styles/cominxin.styl'
.writerBox
    width 100%
    .volumeCon
        width 790px
        box-sizing border-box
        position relative
        height 772px
        border-left 1px solid #d3d3d3
        h4
            margin-left 16px
            font 18px / 40px PingFangSC-Regular, HelveticaNeue-Light, 'Helvetica Neue Light', 'Microsoft YaHei', sans-serif
            text-indent 4px
            margin-top 30px
            padding 0 0 6px
            border-bottom 1px solid #E6E6E6
            span
                color #999
                font-size 12px
                margin-left 12px
        ul
            margin-top 20px
            color #585858
            font 14px / 30px PingFangSC-Regular, HelveticaNeue-Light, 'Helvetica Neue Light', 'Microsoft YaHei', sans-serif
            li
                margin-bottom 20px
                line-height 28px
                span
                    width 80px
                    display inline-block
                    color #888
                    text-align center
                    margin-left 16px
                    line-height 28px
.setVoName
    padding 0px 10px
    font-size 14px
    height 24px
    color rgba(136, 136, 136, 1)
    background #fff
    line-height 24px
    text-align center
    border 1px solid #d3d3d3
    border-radius 4px
    margin-top 10px
    margin-right 16px
    &:hover
        border-color #48A2DF
        color #48A2DF
.setVoBox
        margin 20px 16px 20px
    input
        display block
        width 100%
        margin-right 16px
        box-sizing border-box
        height:40px;
        background:rgba(255,255,255,1);
        box-shadow:0px 2px 6px 0px rgba(216,216,216,0.5);
        border-radius:20px;
        border:1px solid rgba(211,211,211,1);
        padding-left 16px
        placeMain(#BCBCBC, 14px, 0px)
        margin-bottom 20px
        color: #606266;
        font-size 14px
    textarea
        display block
        width 100%
        margin-right 16px
        box-sizing border-box
        height:200px;
        background:rgba(255,255,255,1);
        box-shadow:0px 2px 6px 0px rgba(216,216,216,0.5);
        border-radius:5px;
        border:1px solid rgba(211,211,211,1);
        padding-left 16px
        placeMain(#BCBCBC, 14px, 0px)
        color: #606266;
        font-size 14px
        padding-top 10px
</style>
